module.exports = __webpack_public_path__ + "static/media/p1.1551d230.PNG";